import { z } from 'zod';

export const QInstanceStatusZod = z.union([
    z.literal('Update_In_Progress'),
    z.literal('In_Progress'),
    z.literal('Ready_to_Print'),
    z.literal('Executing_Print'),
    z.literal('Executing_Official'),
    z.literal('Executing_Secure'),
    z.literal('Complete'),
    z.literal('Hidden'),
]);
export type QInstanceStatus = z.infer<typeof QInstanceStatusZod>;
